import React from 'react';
import { useSearch } from '../contexts/SearchContext';

const SearchStatus: React.FC = () => {
  const { searchTerm } = useSearch();

  if (!searchTerm.trim()) {
    return null;
  }

  return (
    <div className="search-status">
      <p>Results for <strong>"{searchTerm}"</strong></p>
    </div>
  );
};

export default SearchStatus;
